import axios from 'axios'
// import store from '@/store/store'

export default () => {
  return axios.create({
    baseURL: process.env.AXIOS_BASE_URL || 'https://admin.z9p.net:8000',
  })
}
